import React from 'react';

import * as R from 'ramda';
import { createPortal } from 'react-dom';
import { NumberParam, useQueryParam } from 'use-query-params';

import PDFPreviewV2 from 'detailsv2/PDFPreviewV2';

import { EDetailsMode } from '../../Itinerary/Details/types';
import PDFPreview from '../PDFPreview';
import { pdfConfig, pdfV2Config } from '../PDFPreview/configs';
import { usePDFPreviewDataWrapper } from './functions';

function PDFPreviewDataWrapper({ itemData, itemId, itemType, accId, prepareItemDataFn = R.identity }) {
  const [images] = useQueryParam('images', NumberParam);
  const { data } = usePDFPreviewDataWrapper({ itemData, itemId, itemType, accId, prepareItemDataFn });

  if (!data) {
    return null;
  }

  if (data.detailsMode === EDetailsMode.Chronological) {
    return createPortal(
      <PDFPreviewV2 data={data} onReady={setPDFReady} config={pdfV2Config[data.type]} showImages={images === 1} />,
      document.body,
    );
  }

  return createPortal(
    <PDFPreview data={data} onReady={setPDFReady} config={pdfConfig[data.type]} showImages={images === 1} />,
    document.body,
  );
}

export default PDFPreviewDataWrapper;

// keep this function here bc it must be always the same on every rendering
function setPDFReady() {
  console.log('---- setPDFReady');
  return (window.pdfReady = true);
}
